import { getCountriesOfHoliday } from "@freightsimple/shared/holidays/holidays";

import type { CountryCode } from "@freightsimple/generated-dashboard-openapi-client/models/CountryCode";
import { Row } from "@freightsimple/ui-core/ComponentLayout/Row";
import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { T } from "@freightsimple/ui-core/Typography/T";
import { asLocalDate } from "@freightsimple/time/branded-types";
import type moment from "moment";
import { pickupHolidaysOn } from "./pickupHolidays";

interface HolidayMessageAlertProps {
  date: moment.Moment;
  country?: CountryCode | undefined;
}

export function DateHolidayMessage({
  date,
  country,
}: HolidayMessageAlertProps) {
  // Without a pickup country this lists only the holidays observed everywhere,
  // so a customer who hasn't entered a postal code yet still sees Christmas Day
  // but isn't warned about Canada Day they may have nothing to do with.
  const holidays = pickupHolidaysOn(
    asLocalDate(date.format("YYYY-MM-DD")),
    country,
  );

  if (holidays.length === 0) {
    return <></>;
  }

  return (
    // align="stretch" keeps the warning glyph at the top when several holidays
    // fall on the same date, which is where it sat before.
    <Row gap={2.5} align="stretch">
      <span>{"⚠️"}</span>
      <Stack gap={0}>
        {holidays.map((h) => (
          <T key={h.description}>
            {h.description + " in "}{" "}
            {getCountriesOfHoliday(h).join(" and ") + "."}
          </T>
        ))}
      </Stack>
    </Row>
  );
}
